import { createAction, props } from '@ngrx/store';
import { LeadAppLinkEntity } from '../../../entities/mdqx/leadapp/lead-app-link.entity';
import { GatewayResponseErrorType } from '../../../services/app-gateway.service';
import { LeadAppLinkActivityEntity } from '../../../entities/mdqx/leadapp/lead-app-link-activity.entity';




const prefix = 'data/' + 'lead-app-link-activity/';
export const LeadAppLinkActivityActionTypes = {
    GetSuccess: createAction(prefix + 'get/success', props<{ Payload: LeadAppLinkActivityEntity[] }>()),
    GetFailure: createAction(prefix + 'get/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
    GetLinkActivityRequestById: createAction(prefix + 'get-by-id/request', props<{ Payload: string }>()),
}
